import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";

export default function ConfirmDeleteMapDialog({
  open,
  setOpen,
  onAccept,
  onCancel,
  mapName,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onAccept: () => void;
  onCancel: () => void;
  mapName: string;
}) {
  return (
    <ActionConfirmDialog
      open={open}
      setOpen={setOpen}
      handleAccept={onAccept}
      handleCancel={onCancel}
      title="Delete Map"
      content={
        <>
          Are you sure you want to delete <strong>{mapName}</strong>? This action cannot be undone.
        </>
      }
      acceptText="Delete"
      cancelText="Cancel"
    />
  );
}
